/*
 * Books-platform integrations a partner can opt into via
 * partner.metadata.booksIntegration. Values name the concrete integration we
 * call, not the books software behind it: ROUTE_MOBILE_ODOO is Route Mobile's
 * custom wrapper API on top of their Odoo. A first-party Odoo integration, if
 * one ever comes, gets its own value. Kept in shared so the backend gate and
 * any admin UI that sets the flag agree on the exact spelling.
 */
export enum BooksIntegrationProvider {
  ROUTE_MOBILE_ODOO = 'route_mobile_odoo',
}
